class VersionDialog extends HTMLElement {
    isOpen = false;
    swipers = []; // swiper实例列表
  
    constructor() {
      super();
      this.init();
    }
  
    init() {
      const dialog = this.querySelector('dialog');
      if (dialog) {
        const observer = new MutationObserver(() => {
          if (dialog.open) {
            window.zzLockBodyScroll && window.zzLockBodyScroll();
            // 初始化swiper
            if (!this.swipers || this.swipers.length === 0) {
              this.initSwiper();
            }
            
          } else {
            // 销毁swiper
            if (this.swipers && this.swipers.length) {
              this.destroySwiper();
            }
          }
        });
  
        // 监听dialog open
        observer.observe(dialog, { attributes: true });
  
        // 添加关闭事件监听
        dialog.addEventListener('close', () => {
          window.zzUnlockBodyScroll && window.zzUnlockBodyScroll();
          // 确保在关闭时销毁swiper
          if (this.swipers && this.swipers.length) {
            this.destroySwiper();
          }
        });
  
        // 添加点击backdrop关闭的事件监听
        dialog.addEventListener('click', (e) => {
          const dialogDimensions = dialog.getBoundingClientRect();
          if (
            e.clientX < dialogDimensions.left ||
            e.clientX > dialogDimensions.right ||
            e.clientY < dialogDimensions.top ||
            e.clientY > dialogDimensions.bottom
          ) {
            dialog.close();
          }
        });
      }
    }
  
    // 初始化
    initSwiper() {
      const swiperContainers = this.querySelectorAll('.swiper');
      if (!swiperContainers.length) return;
  
      // 先销毁已有实例，避免重复初始化
      if (this.swipers && this.swipers.length) {
        this.destroySwiper();
      }
  
      this.swipers = [];
  
      swiperContainers.forEach((swiperContainer) => {
        const slides = swiperContainer.querySelectorAll('.swiper-slide');
        const imageCount = slides.length;
  
        const instance = new Swiper(swiperContainer, {
          slidesPerView: 1,
          spaceBetween: 0,
          pagination: {
            // 分页器限定在当前swiper容器内，避免多个实例互相干扰
            el: swiperContainer.querySelector('.swiper-pagination'),
            type: 'bullets',
            clickable: true,
            dynamicBullets: false,
          },
          navigation: {
            // 同样使用相对选择器
            nextEl: swiperContainer.querySelector('.swiper-button-next'),
            prevEl: swiperContainer.querySelector('.swiper-button-prev'),
          },
          effect: 'slide',
          fadeEffect: {
            crossFade: true,
          },
          loop: imageCount > 1,
          observer: true,
          observeParents: true,
          speed: 500,
          on: {
            init: function () {
              const paginationEl = this.pagination.el;
              const prevButton = swiperContainer.querySelector(
                '.swiper-button-prev'
              );
              const nextButton = swiperContainer.querySelector(
                '.swiper-button-next'
              );
  
              if (imageCount <= 1) {
                if (paginationEl) paginationEl.style.display = 'none';
                if (prevButton) prevButton.style.display = 'none';
                if (nextButton) nextButton.style.display = 'none';
              }
            },
          },
        });
  
        this.swipers.push(instance);
      });
    }
  
    // 销毁
    destroySwiper() {
      if (!this.swipers || !this.swipers.length) return;
  
      // 完全销毁所有swiper实例，包括所有事件监听器和DOM元素
      this.swipers.forEach((instance) => {
        if (instance && typeof instance.destroy === 'function') {
          instance.destroy(true, true);
        }
      });
  
      this.swipers = [];
    }
  }
  
  if (!customElements.get('version-dialog')) {
    customElements.define('version-dialog', VersionDialog);
  }
  